import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LocumsUtility } from 'src/app/locums/locums-utility';
import { StateLicense } from 'src/app/locums/models/state-license.interface';
import { LocumsJobService } from 'src/app/locums/services/locums-job.service';

@UntilDestroy()
@Component({
    selector: 'nova-locums-recruiter-state-licenses',
    templateUrl: './locums-recruiter-state-licenses.component.html',
    styleUrls: ['./locums-recruiter-state-licenses.component.scss']
})
export class LocumsRecruiterStateLicensesComponent implements OnInit {
    @Input() jobId: number;

    stateLicenses: StateLicense[];
    getStateLicenseDetails = LocumsUtility.getStateLicenseDetails;

    constructor(private readonly locumsJobService: LocumsJobService) {}

    ngOnInit(): void {
        this.locumsJobService
            .getStateLicenses(this.jobId)
            .pipe(untilDestroyed(this))
            .subscribe((licenses: StateLicense[]) => {
                this.stateLicenses = licenses;
            });
    }
}
